import {CreateInstance} from './config'
const UserExcelUploadAPI = CreateInstance('users-excel')
export default UserExcelUploadAPI
